import { httpClient } from "@/services";
import { potentialListHeader } from "@/pages/Maintenance/PotentialClient/constants";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		potentialClientsList: [],
		potentialClientsFilter: {},
		potentialClientsFilterDefault: null,
		potentialClients: null,
		deletePotentialClientsList: [],
		deleteInvoiceList: [],
		potentialClientsPreloader: true
	},
	mutations: {
		updatePotentialClientsList(state, { filter, list, isDelete }) {
			if (!isDelete) state.potentialClientsList = list;
			if (filter) state.potentialClientsFilter = filter;
		},
		updatePotentialClientsPreloader(state, payload) {
			state.potentialClientsPreloader = payload;
		},
		updatePotentialClients(state, payload) {
			state.potentialClients = payload;
		},
		updatePotentialClientsDelete(state, { id, isDelete }) {
			if (isDelete) {
				state.deletePotentialClientsList = [];
			} else {
				state.deletePotentialClientsList.push(id);
			}
		},
		updateInvoiceList(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteInvoiceList = [];
			} else {
				state.deleteInvoiceList.push(id);
			}
		},
		updateAddPotentialClientsList(state, { list, id }) {
			const idx = state.potentialClientsList.findIndex(item => item.id === id);

			if (list.status === "Canceled") {
				state.potentialClientsList.splice(idx, 1);
			} else if (idx === -1) {
				state.potentialClientsList.unshift(list);
			} else {
				state.potentialClientsList.splice(idx, 1, list);
			}
		},
		updateListAfterRemoveItem(state, id) {
			const idx = state.potentialClientsList.findIndex(item => item.id === id);
			if (idx !== -1) state.potentialClientsList.splice(idx, 1);
		},
		updateClearPotentialClientsFilter(state) {
			state.potentialClientsFilter = null;
			state.potentialClientsFilterDefault = null;
		}
	},
	actions: {
		onClearPotentialClientsFilter({ commit }) {
			commit('updateClearPotentialClientsFilter');
		},
		onPotentialClientsPreloader({ commit }, value) {
			commit('updatePotentialClientsPreloader', value);
		},
		async onPotentialClientsImport(ctx, file) {
			try {
				const { data } = await httpClient.post('/potentialClients/import', { file });
				if (data && data.status) return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsImportSave({ dispatch }, rows) {
			try {
				const { data } = await httpClient.post('/potentialClients/saveImport', { rows });
				if (data) {
					dispatch('setAlert', { type: 'success', message: 'Save successfully' });
					dispatch('onPotentialClientsFilter', { type: 1 });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClients({ commit, dispatch }, isDelete) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/potentialClients');
				if (data && !data.status) {
					data.isDelete = isDelete;
					commit('updatePotentialClientsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.POTENTIAL, defaultHeader: potentialListHeader });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsEdit({ commit }, id) {
			commit("updatePotentialClientsPreloader", true);
			try {
				const { data } = await httpClient.get(`/potentialClients/${ id }/edit`);
				if (data && !data.status) {
					commit('updatePotentialClients', data);
				}
				commit("updatePotentialClientsPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsCreate({ commit }, id) {
			commit("updatePotentialClientsPreloader", true);
			const url = id ? `/potentialClients/create?customer_id=${ id }` : "/potentialClients/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.status) {
					if (id) {
						return data;
					}
					commit('updatePotentialClients', data);
				}
				commit("updatePotentialClientsPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsSave({ commit, dispatch }, { values, id, typeDefault }) {
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/potentialClients/${ id }` : '/potentialClients';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					const { status, error, list } = data;
					if (!error) {
						commit('updateAddPotentialClientsList', { list, id });
						await dispatch('onPotentialClientsFilter', { type: typeDefault });
					}
					return { status, error };
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/potentialClients/list', payload);
				if (data && !data.status) {
					commit('updatePotentialClientsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.POTENTIAL, defaultHeader: potentialListHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onRemovePotentialClients({ dispatch, commit }, id) {
			dispatch('actionPreloader', true);
			try {
				const { data } = await httpClient.delete(`/potentialClients/${ id }`);
				if (data && data.status) {
					commit('updateListAfterRemoveItem', id);
					dispatch('onPotentialClients', true);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async onPotentialClientsDelete({ state }) {
			if (state.deletePotentialClientsList.length) await httpClient.post(`/potentialClients/destroyDescription`, { ids: state.deletePotentialClientsList });
		},
		async onInvoiceDelete({ state }) {
			if (state.deleteInvoiceList.length) await httpClient.post(`/potentialClients/destroyInvoice`, { ids: state.deleteInvoiceList });
		},
		getPotentialClientsDelete({ commit }, { id, isDelete }) {
			commit('updatePotentialClientsDelete', { id, isDelete });
		},
		getInvoiceDelete({ commit }, { id, isDelete }) {
			commit('updateInvoiceList', { id, isDelete });
		}
	},
	getters: {
		potentialClientsList: s => s.potentialClientsList,
		potentialClientsFilter: s => s.potentialClientsFilter,
		potentialClients: s => s.potentialClients,
		potentialClientsPreloader: s => s.potentialClientsPreloader
	}
};
